'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CheckValues = require('./CheckValues');

var _CheckValues2 = _interopRequireDefault(_CheckValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckFields = function () {
  function CheckFields() {
    _classCallCheck(this, CheckFields);
  }

  _createClass(CheckFields, null, [{
    key: 'CheckTextFields',
    value: function CheckTextFields(requiredFields, firstField) {

      var filled = 0;
      var first = { Key: '', Index: 99999, Step: 1 };
      var reqFields = [];

      if (firstField !== undefined && firstField !== null && firstField !== '') {
        first = firstField;
      }

      if (requiredFields !== null && requiredFields !== undefined && (typeof requiredFields === 'undefined' ? 'undefined' : _typeof(requiredFields)) === "object") {

        reqFields = requiredFields;

        for (var i = 0; i < reqFields.length; i++) {
          if (reqFields[i].Key) {
            if (reqFields[i].Key.props.Id === "Captcha") {
              if (reqFields[i].Key.returnValid() === true) {
                filled++;
              } else {
                if (reqFields[i].Index < first.Index) {
                  first = reqFields[i];
                }
              }
            } else {
              if (document.getElementById(reqFields[i].Key.props.Id).value.length > 0 && !/^\s+$/.test(document.getElementById(reqFields[i].Key.props.Id).value)) {
                if (reqFields[i].Key.props.Id === "Email") {
                  if (reqFields[i].Key.getValid() === true) {
                    filled++;
                  }
                } else {
                  filled++;
                }
                //filled++;
              } else {
                if (reqFields[i].Index < first.Index) {
                  first = reqFields[i];
                }
              }
            }
          } else {
            if (reqFields[i].props.Id === "Captcha") {
              if (reqFields[i].returnValid() === true) {
                filled++;
              } else {
                if (reqFields[i].Index < first.Index) {
                  first = reqFields[i];
                }
              }
            } else {
              if (document.getElementById(reqFields[i].props.Id).value.length > 0) {
                if (reqFields[i].props.Id === "Email") {
                  if (reqFields[i].getValid() === true) {
                    filled++;
                  }
                } else {
                  filled++;
                }
                //filled++;
              }
            }
          }
        }
      }
      return [filled, first];
    }
  }, {
    key: 'CheckSelectFields',
    value: function CheckSelectFields(requiredFields, firstField) {
      var filled = 0;
      var first = { Key: '', Index: 99999, Step: 1 };
      var reqFields = [];

      if (firstField !== undefined && firstField !== null && firstField !== '') {
        first = firstField;
      }

      if (requiredFields !== null && requiredFields !== undefined && (typeof requiredFields === 'undefined' ? 'undefined' : _typeof(requiredFields)) === "object") {
        reqFields = requiredFields;

        for (var i = 0; i < reqFields.length; i++) {
          if (reqFields[i].Key) {
            if (document.getElementById(reqFields[i].Key.props.Id).selectedIndex > 0) {
              filled++;
            } else {
              if (reqFields[i].Index < first.Index) {
                first = reqFields[i];
              }
            }
          } else {
            if (document.getElementById(reqFields[i].props.Id).selectedIndex > 0) {
              filled++;
            }
          }
        }
      }

      return [filled, first];
    }
  }, {
    key: 'CheckCheckBox',
    value: function CheckCheckBox(requiredFields, firstField) {
      var filled = 0;
      var first = { Key: '', Index: 99999, Step: 1 };
      var reqFields = [];

      if (firstField !== undefined && firstField !== null && firstField !== '') {
        first = firstField;
      }

      if (requiredFields !== null && requiredFields !== undefined && (typeof requiredFields === 'undefined' ? 'undefined' : _typeof(requiredFields)) === "object") {
        reqFields = requiredFields;

        for (var j = 0; j < reqFields.length; j++) {
          if (reqFields[j]) {
            if (reqFields[j].Key) {
              if (document.getElementById(reqFields[j].Key.props.Id).checked === true) {
                if (reqFields[j].Key.props.Id === "Captcha") {
                  if (reqFields[j].Key.returnValid() === true) {
                    filled++;
                  }
                } else {
                  filled++;
                }
                //filled++;
              } else {
                if (reqFields[j].Index < first.Index) {
                  first = reqFields[j];
                }
              }
            } else {
              if (document.getElementById(reqFields[j].props.Id).checked === true) {
                if (requiredFields[j].props.Id === "Captcha") {
                  if (requiredFields[j].returnValid() === true) {
                    filled++;
                  }
                } else {
                  filled++;
                }
              }
            }
          }
        }
      }

      return [filled, first];
    }
  }, {
    key: 'CheckFiles',
    value: function CheckFiles(requiredFields) {
      /*let filled = 0;
        for(let i= 0 ; i< this.state.requiredConfirmationFiles.length; i++){
        if(this.state.requiredConfirmationFiles[i].current !== null){
          let file = this.state.requiredConfirmationFiles[i].current.getRequestFiles();
          if (file.length > 0){
            filled++;
          } else {
            
          }
        }
      }
        return filled;*/
    }
  }, {
    key: 'CheckFields',
    value: function CheckFields(textFields, selectFields, checkBoxes, postCodeCityStreet, emailRepeat, tariffingTextFields, tariffingSelectFields) {
      var filled = 0;
      var count = 0;
      var first = null;

      var fields = [];
      if (textFields !== null && textFields !== undefined) {
        for (var i = 0; i < textFields.length; i++) {
          if (textFields[i]) {
            if (textFields[i].Key) {
              fields.push(textFields[i].Key);
            } else {
              fields.push(textFields[i]);
            }
          }
        }
        count += textFields.length;
        var result = this.CheckTextFields(textFields, first);
        filled += result[0];
        first = result[1];
      }

      if (selectFields !== null && selectFields !== undefined) {
        for (var _i = 0; _i < selectFields.length; _i++) {
          if (selectFields[_i]) {
            if (selectFields[_i].Key) {
              fields.push(selectFields[_i].Key);
            } else {
              fields.push(selectFields[_i]);
            }
          }
        }

        count += selectFields.length;
        var _result = this.CheckSelectFields(selectFields, first);
        filled += _result[0];
        first = _result[1];
      }

      if (checkBoxes !== null && checkBoxes !== undefined) {
        count += checkBoxes.length;
        var _result2 = this.CheckCheckBox(checkBoxes, first);
        filled += _result2[0];
        first = _result2[1];
      }

      if (postCodeCityStreet !== null && postCodeCityStreet !== undefined) {
        count += postCodeCityStreet.length;

        var curfields = [];
        for (var _i2 = 0; _i2 < postCodeCityStreet.length; _i2++) {
          if (postCodeCityStreet[_i2]) {
            if (postCodeCityStreet[_i2].current) {
              curfields.push(postCodeCityStreet[_i2].current);
              fields.push(postCodeCityStreet[_i2].current);
            }
          }
        }
        var _result3 = this.CheckTextFields(curfields, first);
        filled += _result3[0];
        first = _result3[1];

        /*for (let i=0;i< postCodeCityStreet.length;i++){
          if (postCodeCityStreet[i]){
            if(postCodeCityStreet[i].current){
              fields.push(postCodeCityStreet[i].current);
              if (document.getElementById(postCodeCityStreet[i].current.props.Id).value.length>0){
                filled++;    
                  
              } 
            }
          }
        }*/
      }

      if (emailRepeat !== null && emailRepeat !== undefined) {
        count += emailRepeat.length;

        var _curfields = [];
        for (var _i3 = 0; _i3 < emailRepeat.length; _i3++) {
          if (emailRepeat[_i3]) {
            if (emailRepeat[_i3].current) {
              _curfields.push(emailRepeat[_i3].current);
              fields.push(emailRepeat[_i3].current);
            }
          }
        }

        var _result4 = this.CheckTextFields(_curfields, first);
        filled += _result4[0];
        first = _result4[1];
        /*for (let i=0;i< emailRepeat.length;i++){
          if (emailRepeat[i]){
            if(emailRepeat[i].current){
              fields.push(emailRepeat[i].current);
              if (document.getElementById(emailRepeat[i].current.props.Id).value.length>0){
                if (emailRepeat[i].current.props.Id === "Email"){
                  if (emailRepeat[i].current.getValid() === true){
                    filled++;
                  }
                }else{
                  filled ++;
                }    
                  
              } 
            }
          }
        }*/
      }

      if (tariffingTextFields !== null && tariffingTextFields !== undefined) {
        count += tariffingTextFields.length;
        if (localStorage.getItem('FixedRoute') === 'true') {
          filled += tariffingTextFields.length;
        } else {
          for (var _i4 = 0; _i4 < tariffingTextFields.length; _i4++) {
            if (tariffingTextFields[_i4]) {
              if (tariffingTextFields[_i4].Key) {
                fields.push(tariffingTextFields[_i4].Key);
              } else {
                fields.push(tariffingTextFields[_i4]);
              }
            }
          }
          var _result5 = this.CheckTextFields(tariffingTextFields, first);
          filled += _result5[0];
          first = _result5[1];
        }
      }

      if (tariffingSelectFields !== null && tariffingSelectFields !== undefined) {
        count += tariffingSelectFields.length;
        if (localStorage.getItem('FixedRoute') === 'true') {
          filled += tariffingSelectFields.length;
        } else {
          for (var _i5 = 0; _i5 < tariffingSelectFields.length; _i5++) {
            if (tariffingSelectFields[_i5]) {
              if (tariffingSelectFields[_i5].Key) {
                fields.push(tariffingSelectFields[_i5].Key);
              } else {
                fields.push(tariffingSelectFields[_i5]);
              }
            }
          }
          var _result6 = this.CheckSelectFields(tariffingSelectFields, first);
          filled += _result6[0];
          first = _result6[1];
        }
      }

      if (filled < count) {
        var docs = document.querySelectorAll('select,input');
        var docRefs = fields;
        _CheckValues2.default.checkAllFields(docs, docRefs, "");
        return [false, first];
      } else {
        return [true, first];
      }
    }
  }]);

  return CheckFields;
}();

exports.default = CheckFields;